import { useAppContext } from "../stores";
export const useAppConfig = () => {
    const { state: { config }, } = useAppContext();
    return config;
};
//# sourceMappingURL=useAppConfig.js.map